import styled from 'styled-components';

export const StyledInputFlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  h2 {
    width: 100%;
  }

  header,
  button {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;

export const StyledContainer = styled.div`
  width: 960px;
  font-family: SourceSansPro;

  h1:first-of-type {
    margin-bottom: 0;
  }
  h1:nth-of-type(3) {
    margin-top: 24px;
  }
`;

export const StyledInputContainer = styled.div`
  width: 464px;

  .MuiButton-contained {
    margin-top: 24px;
    margin-bottom: 32px;
  }
`;

export const ExpandCardTitle = styled.p`
  margin: 8px 0;
  font-family: SourceSansPro;
  font-size: 20px;
  color: #787a84;
`;

export const StyledResultsContainer = styled.div`
  width: 100%;
`;
